// Peor estado entre los resultados. Debe coincidir con el trigger SQL
// public.cables_set_estado_general (falla > alerta > aprobado).
export function worstEstado(resultados) {
  const vals = Object.values(resultados || {});
  if (vals.includes('falla')) return 'falla';
  if (vals.includes('alerta')) return 'alerta';
  return 'aprobado';
}
